// extracted by mini-css-extract-plugin
module.exports = {"select-btn":"cart-select-all_select-btn__zT3fT","select-mobile":"cart-select-all_select-mobile__6btIw","text-mobile":"cart-select-all_text-mobile__Num0m"};